import apiClient from "./ApiService";
import { PATH_CANTONS } from "../config/env";

export const getCantons = async () => {
    return await apiClient.get(PATH_CANTONS);
}

export default getCantons;